// Navigation
export const ENTITY_VIEW_INIT = "ENTITY_VIEW_INIT";
export const ENTITY_VIEW_EXIT = "ENTITY_VIEW_EXIT";

// Entity Data API
export const ENTITY_VIEW_FETCH_ENTITY_DATA = "ENTITY_VIEW_FETCH_ENTITY_DATA";
export const ENTITY_VIEW_RECEIVE_ENTITY_DATA = "ENTITY_VIEW_RECEIVE_ENTITY_DATA";
export const ENTITY_VIEW_RECEIVE_ENTITY_DATA_ERROR = "ENTITY_VIEW_RECEIVE_ENTITY_DATA_ERROR";
export const ENTITY_VIEW_RECEIVE_ENTITY_DATA_RETRY = "ENTITY_VIEW_RECEIVE_ENTITY_DATA_RETRY";

// Entity Relation Data API
export const ENTITY_VIEW_FETCH_ENTITY_RELATION_DATA = "ENTITY_VIEW_FETCH_ENTITY_RELATION_DATA";
export const ENTITY_VIEW_RECEIVE_ENTITY_RELATION_DATA = "ENTITY_VIEW_RECEIVE_ENTITY_RELATION_DATA";
export const ENTITY_VIEW_RECEIVE_ENTITY_RELATION_DATA_ERROR = "ENTITY_VIEW_RECEIVE_ENTITY_RELATION_DATA_ERROR";
export const ENTITY_VIEW_RECEIVE_ENTITY_RELATION_DATA_RETRY = "ENTITY_VIEW_RECEIVE_ENTITY_RELATION_DATA_RETRY";

// Graph Data API
export const ENTITY_VIEW_FETCH_GRAPH_DATA = "ENTITY_VIEW_FETCH_GRAPH_DATA";
export const ENTITY_VIEW_RECEIVE_GRAPH_DATA = "ENTITY_VIEW_RECEIVE_GRAPH_DATA";
export const ENTITY_VIEW_RECEIVE_GRAPH_DATA_ERROR = "ENTITY_VIEW_RECEIVE_GRAPH_DATA_ERROR";
export const ENTITY_VIEW_RECEIVE_GRAPH_DATA_RETRY = "ENTITY_VIEW_RECEIVE_GRAPH_DATA_RETRY";
export const ENTITY_VIEW_FETCH_EXPAND_GRAPH_DATA = "ENTITY_VIEW_FETCH_EXPAND_GRAPH_DATA";
export const ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA = "ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA";
export const ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA_ERROR = "ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA_ERROR";
export const ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA_RETRY = "ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA_RETRY";
export const ENTITY_VIEW_SET_GRAPH_DEPTH = "ENTITY_VIEW_SET_GRAPH_DEPTH";
export const ENTITY_VIEW_SET_GRAPH_EXPAND_DEPTH = "ENTITY_VIEW_SET_GRAPH_EXPAND_DEPTH";
export const ENTITY_VIEW_SET_GRAPH_SETTINGS_EXPANDED = "ENTITY_VIEW_SET_GRAPH_SETTINGS_EXPANDED";
export const ENTITY_VIEW_SET_GRAPH_FILTERS_EXPANDED = "ENTITY_VIEW_SET_GRAPH_FILTERS_EXPANDED";
export const ENTITY_VIEW_STEP_BACK = "ENTITY_VIEW_STEP_BACK";

// Media Mentions Data API
export const ENTITY_VIEW_FETCH_MEDIA_MENTIONS = "ENTITY_VIEW_FETCH_MEDIA_MENTIONS";
export const ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS = "ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS";
export const ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS_ERROR = "ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS_ERROR";
export const ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS_RETRY = "ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS_RETRY";

// Media Mentions UI State
export const ENTITY_VIEW_SET_MEDIA_MENTIONS_CURSOR_POS = "ENTITY_VIEW_SET_MEDIA_MENTIONS_CURSOR_POS";
export const ENTITY_VIEW_RESET_MEDIA_MENTIONS_CURSOR_POS = "ENTITY_VIEW_RESET_MEDIA_MENTIONS_CURSOR_POS";
export const ENTITY_VIEW_SET_MEDIA_MENTIONS_SORT = "ENTITY_VIEW_SET_MEDIA_MENTIONS_SORT";

// Corporate Records UI State
export const ENTITY_VIEW_SET_CORP_RECORDS_CURSOR_POS = "ENTITY_VIEW_SET_CORP_RECORDS_CURSOR_POS";
export const ENTITY_VIEW_SET_CORP_RECORDS_SORT = "ENTITY_VIEW_SET_CORP_RECORDS_SORT";

// Procurement Data UI State
export const ENTITY_VIEW_SET_PROCUREMENT_DATA_CURSOR_POS = "ENTITY_VIEW_SET_PROCUREMENT_DATA_CURSOR_POS";
export const ENTITY_VIEW_SET_PROCUREMENT_DATA_SORT = "ENTITY_VIEW_SET_PROCUREMENT_DATA_SORT";

// TimeSeries
export const ENTITY_VIEW_FETCH_TIME_SERIES = "ENTITY_VIEW_FETCH_TIME_SERIES";
export const ENTITY_VIEW_RECEIVE_TIME_SERIES = "ENTITY_VIEW_RECEIVE_TIME_SERIES";
export const ENTITY_VIEW_RECEIVE_TIME_SERIES_ERROR = "ENTITY_VIEW_RECEIVE_TIME_SERIES_ERROR";
export const ENTITY_VIEW_RECEIVE_TIME_SERIES_RETRY = "ENTITY_VIEW_RECEIVE_TIME_SERIES_RETRY";
export const ENTITY_VIEW_SET_TIME_SERIES_SHRUNK = "ENTITY_VIEW_SET_TIME_SERIES_SHRUNK";
export const ENTITY_VIEW_SET_TIME_SERIES_AGGREGATION_LEVEL = "ENTITY_VIEW_SET_TIME_SERIES_AGGREGATION_LEVEL";
export const ENTITY_VIEW_TIME_SERIES_ZOOM_COMPLETE = "ENTITY_VIEW_TIME_SERIES_ZOOM_COMPLETE";
export const ENTITY_VIEW_FORMAT_CONTENT_FILTERED_BY_DATE = "ENTITY_VIEW_FORMAT_CONTENT_FILTERED_BY_DATE";
export const ENTITY_VIEW_SET_CONTENT_FILTERED_BY_DATE = "ENTITY_VIEW_SET_CONTENT_FILTERED_BY_DATE";

// General UI State
export const ENTITY_VIEW_SET_GEN_INFO_WIDGET_EXPANDED = "ENTITY_VIEW_SET_GEN_INFO_WIDGET_EXPANDED";
export const ENTITY_VIEW_SET_OWNERSHIP_WIDGET_EXPANDED = "ENTITY_VIEW_SET_OWNERSHIP_WIDGET_EXPANDED";
export const ENTITY_VIEW_SET_SANCTIONS_WIDGET_EXPANDED = "ENTITY_VIEW_SET_SANCTIONS_WIDGET_EXPANDED";
export const ENTITY_VIEW_SET_ONLINE_INFO_WIDGET_EXPANDED = "ENTITY_VIEW_SET_ONLINE_INFO_WIDGET_EXPANDED";
export const ENTITY_VIEW_SET_AFFILIATIONS_WIDGET_EXPANDED = "ENTITY_VIEW_SET_AFFILIATIONS_WIDGET_EXPANDED";
export const ENTITY_VIEW_SET_TIME_SERIES_WIDGET_EXPANDED = "ENTITY_VIEW_SET_TIME_SERIES_WIDGET_EXPANDED";
export const ENTITY_VIEW_SET_MEDIA_MENTIONS_WIDGET_EXPANDED = "ENTITY_VIEW_SET_MEDIA_MENTIONS_WIDGET_EXPANDED";
export const ENTITY_VIEW_SET_PROCUREMENT_WIDGET_EXPANDED = "ENTITY_VIEW_SET_PROCUREMENT_WIDGET_EXPANDED";
export const ENTITY_VIEW_SET_CORPORATE_RECORDS_WIDGET_EXPANDED = "ENTITY_VIEW_SET_CORPORATE_RECORDS_WIDGET_EXPANDED";
export const ENTITY_VIEW_SET_OTHER_PROPS_WIDGET_EXPANDED = "ENTITY_VIEW_SET_OTHER_PROPS_WIDGET_EXPANDED";
export const ENTITY_VIEW_RESET_ALL_CURSOR_POS = "ENTITY_VIEW_RESET_ALL_CURSOR_POS";
export const ENTITY_VIEW_SET_SHOW_NATIVE_LANGUAGE = "ENTITY_VIEW_SET_SHOW_NATIVE_LANGUAGE";
export const ENTITY_VIEW_SET_DISABLE_EXPORT_BUTTON = "ENTITY_VIEW_SET_DISABLE_EXPORT_BUTTON";
export const ENTITY_VIEW_SET_EXPORT_OPTIONS = "ENTITY_VIEW_SET_EXPORT_OPTIONS";
export const ENTITY_VIEW_SET_SHOW_GRAPH_LABELS = "ENTITY_VIEW_SET_SHOW_GRAPH_LABELS";
export const ENTITY_VIEW_SET_SHOW_GRAPH_EDGE_LABELS = "ENTITY_VIEW_SET_SHOW_GRAPH_EDGE_LABELS";
export const ENTITY_VIEW_SET_GRAPH_LAYOUT_RUNNING = "ENTITY_VIEW_SET_GRAPH_LAYOUT_RUNNING";
export const ENTITY_VIEW_SET_OWNERSHIP_VIEW_MODE = "ENTITY_VIEW_SET_OWNERSHIP_VIEW_MODE";
export const ENTITY_VIEW_TOGGLE_CHAT_OPEN = "ENTITY_VIEW_TOGGLE_CHAT_OPEN";